import { getStoreSelfExtract, getZtOrder, getMerchantList, getJielongActList, sendMsgRemind, latestExpressSearchApi, myShareJielongActListApi } from "@/libs/api";
import orderItem from "@/components/pickup/orderItem.vue";
export default {
  name: "pickupList",
  components: { orderItem },
  data() {
    return {
      loading: false,
      finished: true,
      finishedText: "",
      isLoad: false,
      hasSelf: false,
      listStatus: 0, // 0-无状态 1-有数据 2-无数据
      isShowSelfList: false,
      isShowBatch: false,
      isShowSelect: false,
      isShowQuery: false,
      myListIsLoad: false,
      isShowSelectFy: false,
      columns: [],
      businessList: [], // 商家列表
      chainsList: [], // 接龙列表
      currentSelectName: "请选择",
      currentSelectNameFy: "请选择",
      currentSelectId: "",
      currentSelectIdFy: "",
      radio: "1",
      selfList: [],
      orderListArr: [],
      currentSiteId: "",
      currentSiteName: "加载中...",
      query: {
        pageSize: 10,
        startIndex: 1,
        siteId: "",
        keywords: "",
        orderStatus: 5,
        jieLongOrderFlag: "",
        unionRef: "",
      },
      tabActive: 0,
      navObj: [
        {
          title: "已发货",
          status: 5,
          id: 0,
        },
        {
          title: "待付款",
          status: 3,
          id: 1,
        },
        {
          title: "已核销",
          status: 7,
          id: 2,
        },
        {
          title: "全部",
          status: 0,
          id: 3,
        },
      ],
      keywords: "",
      logisticsList: {},
      popQueryNav: [
        {
          name: "全部",
          code: "",
        },
        {
          name: "接龙销售",
          code: "1",
        },
        {
          name: "单品",
          code: "0",
        },
      ],
      popQueryIndex: 0,
      popChainsList: [],
      topName: "全部",
      freshActType: "",
      columnsFy: [
        {
          text: "24小时内到货末签收订单",
          id: 24,
        },
        {
          text: "48小时内到货末签收订单",
          id: 48,
        },
      ],
      getGoodsDay:'今日',
      getGoodsTime:'',
      showGetGoodsAction:false,
      actions:[
        {name:'今日',color:'#ef3b39'},
        {name:'明日',color:'#333333'},
      ],
      disabledOne:false,
      disabledTwo:false,
    };
  },
  mounted() {
    console.log("改3");
    this.getSelf();
    this.appGetPioltFlag();
  },
  methods: {
    resetTimeAlert(){
      this.getGoodsTime='';
    },
    //设置提货时间后修改按钮状态
    chnageBtn(){
      if(this.freshActType != 1){
        this.disabledOne = this.currentSelectId  && this.getGoodsTime;
      }else{
        this.disabledTwo = this.currentSelectIdFy && this.getGoodsTime;
      }
    },
    //切换提货时间
    chnageGetGoodsDay(e){
      this.getGoodsDay = e.name;
      this.actions.forEach((item)=>{
        item.color='#333333';
      })
      e.color='#ef3b39';
      this.showGetGoodsAction=false;
    },
    // 获取试点信息
    appGetPioltFlag() {
      var _this = this;
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        console.log("sssssssssss=", s);
        if (s) {
          _this.freshActType = "1";
        } else {
          _this.freshActType = "2";
        }
      });
    },
    // 获取自提点列表
    getSelf() {
      getStoreSelfExtract({ clientCallType: "H5" }, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          this.selfList = res.data;
          if (res.data.length > 0) {
            this.hasSelf = true;
            this.query.siteId = res.data[0].siteId;
            this.currentSiteId = res.data[0].siteId;
            this.currentSiteName = res.data[0].siteName;
            this.currentSiteAddress = res.data[0].address;
            this.selfList.forEach((item) => {
              item.text = item.siteName;
            });
            this.fetch();
          } else {
            this.currentSiteName = "暂无自提点";
            this.hasSelf = false;
            this.listStatus = 2;
          }
        }
      });
    },
    // 获取自提订单列表
    fetch() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      getZtOrder(this.query, "jsonCallback").then((res) => {
        this.loading = false;
        this.finished = false;
        let pkgInfo = [];
        if (res.returnCode === "0000") {
          this.$toast.clear();
          if (!res.data) {
            this.listStatus = 2;
            this.finished = true;
            this.finishedText = "";
          } else {
            this.listStatus = 1;
            // console.log("data====", res.data);
            res.data.forEach((item) => {
              if (item.orderStatus != 3 && item.orderStatus != 4) {
                pkgInfo.push({
                  packageNo: item.delevery[0].packageId,
                  escOrderId: item.escOrderId,
                });
              }
            });
            // console.log("pkgInfo====", pkgInfo);
            let pkgInfoJson = JSON.stringify(pkgInfo);
            // console.log("pkgInfoJson", pkgInfoJson);
            this.getLogisticsInfo(pkgInfoJson);
            this.orderListArr = this.orderListArr.concat(res.data);
            console.log("orderListArr", this.orderListArr);
            let totalPages = Math.ceil(res.total / this.query.pageSize);
            // if (this.query.pageSize * this.query.startIndex >= res.total) {
            if (this.query.startIndex == totalPages) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.finished = false;
              this.query.startIndex++;
            }
          }
        } else {
          this.finished = true;
        }
      });
    },
    getLogisticsInfo(pkgInfoJson) {
      latestExpressSearchApi({ pkgInfoJson: pkgInfoJson, clientCallType: "H5" }).then((res) => {
        if (res.returnCode == "0000") {
          this.logisticsList = { ...this.logisticsList, ...res.data };
        }
      });
    },
    // 选择自提点
    changeSite(item) {
      this.isLoad = false;
      this.orderListArr = [];
      this.currentSiteId = item.siteId;
      this.currentSiteName = item.siteName;
      this.query.siteId = item.siteId;
      this.query.startIndex = 1;
      this.isShowSelfList = false;
      this.listStatus = 0;
      this.finishedText = "";
      this.radio = "1";
      this.fetch();
    },
    // 导航切换
    tapNav(id) {
      this.query.orderStatus = this.navObj[id].status;
      this.orderListArr = [];
      this.query.startIndex = 1;
      this.listStatus = 0;
      this.finishedText = "";
      this.fetch();
    },
    // 选择框确认
    onConfirm(value) {
      this.isShowSelect = false;
      this.currentSelectName = value.text;
      this.currentSelectId = value.id;
      this.disabledOne = value.id && this.getGoodsTime;
      // this.$toast(`当前值：${value.id}, 当前索引：${index}`);
    },
    // 选择框确认
    onConfirmFy(value) {
      console.log("value====", value);
      this.isShowSelectFy = false;
      this.currentSelectNameFy = value.text;
      this.currentSelectIdFy = value.id;
      this.disabledTwo = value.id && this.getGoodsTime;
      // this.$toast(`当前值：${value.id}, 当前索引：${index}`);
    },
    // 选择框取消
    onCancel() {
      this.isShowSelect = false;
      this.currentSelectName = "请选择";
      this.currentSelectId = "";
      this.chnageBtn()
    },
    // 选择框取消
    onCancelFy() {
      this.isShowSelectFy = false;
      this.currentSelectNameFy = "请选择";
      this.currentSelectIdFy = "";
      this.chnageBtn()
    },
    // 批量通知弹层
    showBatch() {
      console.log("freshActType", this.freshActType);
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      // 试点
      if (this.freshActType == 1) {
        if (this.orderListArr.length > 0) {
          this.$toast.clear();
          this.isShowBatch = true;
        } else {
          this.$toast("当前没有符合的订单！");
        }
      }
      // 非试点
      else {
        Promise.all([getMerchantList({ siteId: this.currentSiteId }, "jsonCallback"), getJielongActList({ siteId: this.currentSiteId }, "jsonCallback")]).then((res) => {
          this.$toast.clear();
          if (res[0].data.length > 0 || res[1].data.length > 0) {
            if (this.radio === "1") {
              this.columns = res[0].data;
            } else {
              this.columns = res[1].data;
            }
            this.businessList = res[0].data;
            this.chainsList = res[1].data;
            this.isShowBatch = true;
            // 如果商家列表没有,则默认选中接龙
            if (res[0].data.length === 0) {
              this.radio = 2;
            }
          } else {
            this.$toast("当前没有符合的订单！");
          }
        });
      }
    },
    // 单选切换
    getCurrentRadio(name) {
      this.columns = [];
      this.currentSelectName = "请选择";
      this.currentSelectId = "";
      if (name === "1") {
        this.columns = this.businessList;
      } else if (name === "2") {
        this.columns = this.chainsList;
      }
    },
    // 批量发送消息
    batchMessage() {
      let data = {
        queryType: "", // 发送类型
        escOrderid: "", // 订单号
        sellerOnlyId: "", // 商家ID
        unionRef: "", // 接龙ID
        ziTiStoreId: this.currentSiteId, // 自提点ID
        day:this.getGoodsDay=='今日'?'0':'1',
        sendTime:this.getGoodsTime,
      };
      // 按商家
      if (this.radio === "1") {
        data.queryType = 1;
        data.sellerOnlyId = this.currentSelectId;
        data.unionRef = "";
      }
      // 按接龙
      else {
        data.queryType = 2;
        data.sellerOnlyId = "";
        data.unionRef = this.currentSelectId;
      }
      this.$dialog
        .confirm({
          title: "发送短消息",
          message: "确认发送短消息",
          confirmButtonText: "确认发送",
          cancelButtonText: "取消",
        })
        .then(() => {
          sendMsgRemind(data, "jsoncallback").then((res) => {
            if (res.returnCode === "0000") {
              this.$toast("短信发送成功");
              this.isShowBatch = false;
              this.currentSelectId = "";
              this.currentSelectName = "";
            } else {
              this.$toast(res.returnMessage);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 批量发送消息
    batchMessageFy() {
      let data = {
        queryType: "3", // 发送类型
        escOrderid: "", // 订单号
        ziTiStoreId: this.currentSiteId, // 自提点ID
        orderRange: "",
        day:this.getGoodsDay=='今日'?'0':'1',
        sendTime:this.getGoodsTime,
      };
      data.orderRange = this.currentSelectIdFy;
      console.log("data=====", data);
      this.$dialog
        .confirm({
          title: "发送短消息",
          message: "确认发送短消息",
          confirmButtonText: "确认发送",
          cancelButtonText: "取消",
        })
        .then(() => {
          sendMsgRemind(data, "jsoncallback").then((res) => {
            if (res.returnCode === "0000") {
              this.$toast("短信发送成功");
              this.isShowBatch = false;
              this.currentSelectIdFy = "";
              this.currentSelectNameFy = "请选择";
            } else {
              this.$toast(res.returnMessage);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 搜索跳转
    handleSearch() {
      console.log("回车", this.keywords);
      if (this.keywords == "") return;
      this.toNext("/pickup/pickupSearch", { siteId: this.currentSiteId, keywords: this.keywords });
    },
    // 条件列表点击
    handleShowQuery() {
      this.isShowQuery = true;
      let query = {
        startIndex: 1,
        pageSize: 100,
        clientCallType: "H5",
        siteId: this.currentSiteId,
      };
      myShareJielongActListApi(query, "jsonCallback").then((res) => {
        if (res.returnCode == "0000") {
          this.popChainsList = res.data.xcxList;
          // this.popChainsList.unshift({
          //   activityId: "",
          //   activityName: "全部接龙",
          // });
        }
      });
    },
    // 条件切换
    handlePopQueryChangle(item, index) {
      this.popQueryIndex = index;
      if (index != 1) {
        this.topName = item.name;
        this.query.jieLongOrderFlag = item.code;
        this.orderListArr = [];
        this.query.startIndex = 1;
        this.listStatus = 0;
        this.finishedText = "";
        this.fetch();
        this.isShowQuery = false;
      }
    },
    // 接龙选择
    handleChainSelect(item) {
      console.log(item);
      this.query.jieLongOrderFlag = "1";
      this.query.unionRef = item.activityId;
      this.topName = item.activityName;
      this.orderListArr = [];
      this.query.startIndex = 1;
      this.listStatus = 0;
      this.finishedText = "";
      this.fetch();
      this.isShowQuery = false;
    },
    // 全部接龙
    handleAllChain() {
      this.query.jieLongOrderFlag = "1";
      this.query.unionRef = "";
      this.topName = "全部接龙";
      this.orderListArr = [];
      this.query.startIndex = 1;
      this.listStatus = 0;
      this.finishedText = "";
      this.fetch();
      this.isShowQuery = false;
    },
  },
};
